export enum QueueType {
    Unknown = 0,
    UploadSeismic2D = 1,
    UploadSeismic3D = 2,
    UploadShapefile = 3,
    UploadTiff = 4,
    UploadGrid = 5,
    CompositeProfile = 6,
}
